module.exports = __webpack_public_path__ + "img/L 10.eb19c894.png";